function isSelfTarget(event) {
  return event.target === event.currentTarget;
}

export { isSelfTarget };